import * as React from 'react';

import {useGetSalesObjectionContext} from '../graphql/hooks/use-get-sales-objection-context';
import {SALES_OBJECTION_AGENT, updateSalesObjectionContext} from '../helpers';
import {TeamAiAgent} from '../team-ai-agent';

export function SalesObjectionAgent() {
    const {context: objectionContext} = useGetSalesObjectionContext();

    const onInitializeChatbot = (chatbot: any): void => {
        if (objectionContext) {
            updateSalesObjectionContext(chatbot, objectionContext);
        }
    };

    return (
        <TeamAiAgent
            agentKey={SALES_OBJECTION_AGENT}
            onInitializeChatbot={onInitializeChatbot}
            pageContext={null}
        />
    );
}
